export interface CommentDto {
  id?: number,
  comment?: string
}

export function emptyComment(): CommentDto {
  return {
    id: 0,
    comment: ""
  }
}
